import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

localStorage.setItem("i18nextLng", "pt");

i18n.use(LanguageDetector).init({
	debug: false,
	lng: "pt-BR",
	defaultNS: ["translations"],
	fallbackLng: "pt-BR",
	ns: ["translations"],
	resources: messages,
});

export { i18n };
